module.exports = __webpack_public_path__ + "55b50f7887e845fa022133209e83c71c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/event-edit-black.png
// module id = 215
// module chunks = 0